import { useLayoutEffect, useRef } from 'react'
import { useI18n } from '../../i18n/I18nContext'
import type { useTableSelection } from '../../hooks/useTableSelection'
type Selection = ReturnType<typeof useTableSelection>
export function TablePageSelection({selection}:{selection:Selection}) {
  const {t}=useI18n(),ref=useRef<HTMLInputElement>(null)
  useLayoutEffect(()=>{if(ref.current)ref.current.indeterminate=selection.some},[selection.some])
  return <label className="table-selection-target"><input ref={ref} type="checkbox" aria-label={t('Select eligible records on this page')}
    disabled={!selection.enabled||!selection.eligibleCount} checked={selection.all} aria-checked={selection.some?'mixed':selection.all}
    onChange={()=>selection.all?selection.clear():selection.selectPage()} /></label>
}
export function TableRowSelection({selection,id,name}:{selection:Selection;id:string;name:string}) {
  const {t}=useI18n()
  return <label className="table-selection-target"><input type="checkbox" aria-label={t('Select {name}',{name})} checked={selection.isSelected(id)}
    disabled={!selection.canSelect(id)} onChange={()=>selection.toggle(id)} /></label>
}
